import $store from '../store'

const AppMixin = {
  install(Vue, options) {
    Vue.mixin({
      data() {
        return {
				  dataTableFixedHeight: 400
        }
      },
      mounted() {
        this.dataTableFixedHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      },
      methods: {
        checkPermission(claim) {
          if (!claim)
            return true
          var userClaims = $store.getters['auth/getCurrentUserClaims']
          return userClaims && userClaims.findIndex(x => x.value === claim) > -1
        },
        checkActivePart(part) {
          var activeParts = $store.getters['siteConfig/activeParts']
          return !part || (activeParts && activeParts[part])
        }
      }
    })
  }
}

export default AppMixin
